<template>
    
    <div v-if='unreadThreads.length' class="p-3">
        <!-- <button v-on:click.prevent='navigateToUnread' class="btn btn-light btn-block btn-round">
            You have new messages in <span class="float-none d-inline-block badge badge-primary badge-pill">{{unreadThreads.length}}</span> thread{{(unreadThreads.length != 1 ? "s" : "")}}
        </button> -->
        <div class="info--unread-message">
            <p><strong>{{ $t('translations.you_have')}} {{unreadThreads.length}} {{ $t('translations.unread_message')}}{{(unreadThreads.length != 1 ? "s" : "")}}</strong></p>
            <img src="/img/egl/icon-new-message.svg" alt="new messages in consultation" style="width: 100%; max-width: 340px;">
            <br>
            <p v-on:click.prevent='navigateToUnread' class="small btn btn-primary btn-round pl-3 pr-3">{{ $t('translations.view_messages')}}</p>
            <hr>
        </div>
    </div>

    <div v-else>
        <div v-if="$root.isLoggedIn()">
            <p><strong>{{ $t('translations.up_to_date')}}</strong></p>
            <!-- <img src="/img/egl/icon-new-message.svg" alt="new messages in consultation" style="width: 100%"> -->
            <br>
            <button class="small btn btn-primary btn-round disabled">No messages</button>
            <hr>
        </div>
    </div>

</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            unreadThreads: [],
        }
    },
    mounted() {
        if(this.$root.isLoggedIn()) {
            this.getUnreadThreads();
            
            window.Echo.private('patient.' + this.$root.user.id)
                .listen('NewPatientThread', (e) => {
                    this.getUnreadThreads();
                });

            this.listenWithChunking('patient.' + this.$root.user.id, 'UpdatePatientThread', (e) => {
                this.getUnreadThreads();
            });
        }
    },
    beforeDestroy() {
        if(this.$root.isLoggedIn()) {
            this.deinitData();
        }
    },
    methods: {
        deinitData() {
            window.Echo.leave('patient.' + this.$root.user.id);
        },

        getUnreadThreads() {
            axios.get('/api/vp1/threads/getUnreadThreads').then((res) => {
                this.unreadThreads = res.data;

            }).catch((error) => {
                this.handleError(error, "create");
            });
        },
        
        navigateToUnread() {
            if(this.unreadThreads.length == 1) {
                this.$router.push({path: "/thread-show/" + this.unreadThreads[0].id});
            }//$root.isLoggedIn() ? {name: "threadList"} : {name: "loginType"}
            else {
                this.$router.push({name: "threadList"});

            }
        },
    }
}

</script>
